import { render, staticRenderFns } from "./moneyHalo.vue?vue&type=template&id=0f474016&scoped=true&"
import script from "./moneyHalo.vue?vue&type=script&lang=js&"
export * from "./moneyHalo.vue?vue&type=script&lang=js&"
import style0 from "./moneyHalo.vue?vue&type=style&index=0&id=0f474016&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f474016",
  null
  
)

export default component.exports